
import React, { memo, useCallback } from 'react';
import { Grid, Button } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { collectionHelper } from '../../../../utilities/basicUtilities';
import PresetCard from './PresetCard';

const styles = theme => ({
    showMoreButton: {
        margin: theme.spacing(2)
    }
});

const PresetList = memo(({ presets, count, onShowMoreClick, classes }) => {
    const renderPresets = useCallback((presetCount) => {
        const filteredPresets = (presetCount < presets.length)
            ? collectionHelper(presets).getWhere((p) => presets.indexOf(p) < presetCount)
            : presets;

        return filteredPresets.map((preset, index) => (
            <Grid key={preset.id}>
                <PresetCard index={index} />
            </Grid>
        ));
    }, [presets]);

    return (
        <Grid
            container
            direction='row'
            justifyContent='center'
            alignItems='flex-start'
            spacing={4}
        >
            {count ? (
                <>
                    {renderPresets(count)}
                    <Button
                        onClick={onShowMoreClick}
                        color='primary'
                        variant='outlined'
                        className={classes.showMoreButton}
                    >
                        Show More
                    </Button>
                </>
            ) : (
                renderPresets()
            )}
        </Grid>
    );
});

export default withStyles(PresetList, styles);